<template>
  <v-alert id="tax-guide-alert" color="softInfo" icon="mdi-star" class="mb-0 mt-4">
    {{ $t('views.tax.guideAlert.text1') }}
    <a href="https://www.filios.app/guia-de-fiscalidad/" target="_blank">
      {{ $t('views.tax.guideAlert.text2') }}
    </a>
    {{ $t('views.tax.guideAlert.text3') }}
  </v-alert>
</template>

<script>
export default {}
</script>

<style lang="scss">
#tax-guide-alert {
  .v-alert__content {
    font-size: 15px;
    a {
      font-weight: 400;
      text-decoration: none;
    }
  }
}
</style>
